import { render, staticRenderFns } from "./safetyImages.vue?vue&type=template&id=7cb98c8c&scoped=true"
import script from "./safetyImages.vue?vue&type=script&lang=js"
export * from "./safetyImages.vue?vue&type=script&lang=js"
import style0 from "./safetyImages.vue?vue&type=style&index=0&id=7cb98c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb98c8c",
  null
  
)

export default component.exports